module.exports = __webpack_public_path__ + "661623ad.png";